var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KSelect',{attrs:{"label":"Select an option","options":_vm.options,"value":_vm.options[0],"disabled":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }